import styled from "styled-components"

import Heading from "components/Typography/Heading"
import { useCallback } from "react"
import SelectV2, { Option } from "components/EvtKit/select/SelectV2"
import ApiProducts from "api/ApiProducts"
import IconError from "components/icons/IconError"
import { Colors } from "themes/palette"
import clsx from "clsx"
import CreateApiMappingButton from "./CreateApiMappingButton"
import ApiMappingBoard from "./apiMappingBoard"

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-right: 24px;
`

const TitleContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`

const Title = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`

const SelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 24px 0;
`

const ProductContainer = styled.div`
  display: flex;
  width: 288px;
`

const ContainerIcon = styled.div`
  display: flex;
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
  }
`

interface apiMappingHeaderProps {
  data: App.ApiMapping[]
  filters: App.ApiMappingFilters
  setFilters: React.Dispatch<React.SetStateAction<App.ApiMappingFilters>>
  initialFilters: App.ApiMappingFilters
}

export const ApiMappingHeader = (props: apiMappingHeaderProps) => {
  const { data, filters, setFilters, initialFilters } = props

  const handleProductChange = useCallback((option: Option | null) => {
    setFilters((prev) => ({
      ...prev,
      product: option?.value
    }))
  }, [])

  const getDataToProducts = useCallback(async () => {
    const response = await new ApiProducts().listExternalProducts()

    const data = response.data.map((product) => ({
      value: product.id,
      label: product.prefixUrl
    }))

    return {
      hasMore: false,
      results: data
    }
  }, [])

  const handleClearFilters = useCallback(() => {
    setFilters(initialFilters)
  }, [])

  return (
    <>
      <TitleContent>
        <Title>
          <Heading variant="h3">API Endpoints</Heading>
        </Title>
        {data.length > 0 && (
          <ButtonContainer>
            <CreateApiMappingButton title="Criar Endpoint" />
          </ButtonContainer>
        )}
      </TitleContent>
      <SelectContainer>
        <ProductContainer>
          <SelectV2
            id="product"
            label="Filtrar por produto"
            getData={getDataToProducts}
            value={filters.product || ""}
            onChange={handleProductChange}
          />
        </ProductContainer>
        <ContainerIcon onClick={handleClearFilters} className={clsx({ disabled: !filters.product })}>
          <IconError color={filters.product ? Colors.primary_dark : Colors.disabled} />
        </ContainerIcon>
      </SelectContainer>
      {data.length === 0 && <ApiMappingBoard filterValue={filters.product || ""} />}
    </>
  )
}
